import { currencyFormat } from "../../utils/helper";
import { format } from "date-fns";
import QRCode from "react-qr-code";

var converter = require("number-to-words");

export default function EndowmentPlanPolicyPaper({ policyData }) {
  const QRCodeData = {
    "Policy No": policyData.policyNo,
    "Full Name": policyData.insuredName,
    DOB: format(new Date(policyData.dob), "yyyy/MM/dd"),
    DOC: format(new Date(policyData.doc), "yyyy/MM/dd"),
    "Documents Number": policyData.documentNo,
    "Sum Assured": currencyFormat(policyData.sumAssured),
  };
  let formattedText = "";
  for (const key in QRCodeData) {
    formattedText += `${key}: ${QRCodeData[key]}\n`;
  }

  const header = () => {
    return (
      <>
        <div className="flex justify-between items-center mb-2">
          <div></div>
          <div className="flex items-center">
            <img
              className="mr-2"
              src="/images/logo.png"
              style={{ height: "70px" }}
              alt="IME Life Insurance"
            />
            <div>
              <h1 className="text-center font-bold">सन नेपाल</h1>
              <h1 className="text-center font-bold">
                लाइफ इन्स्योरेन्स कं. लि.
              </h1>
            </div>
          </div>
          <QRCode
            size={256}
            style={{ height: "100", width: "auto" }}
            value={formattedText}
            viewBox={`0 0 256 256`}
          />
        </div>
        <div className="policy-paper--small text-center">
          कम्पनी ऐन २०६३ दर्ता नं १०३०/०६४/०६५ स्थायी लेखा नं. ६०६१४२८२१, बीमक
          दर्ता नं. १३/०७४
        </div>
        <div className="policy-paper--small text-center mb-3">
          कर्पोरेट कार्यालय: पुतलीसड़क, न्यू प्लाजा काठमाण्डौ, पो. ब. नं ५७७
        </div>
      </>
    );
  };

  return (
    <>
      <div className="policy-paper-wrapper mb-4">
        {header()}
        <h6 className="text-center font-bold mb-4">
          सन लाइफ सावधिक जीवन बीमालेख
        </h6>
        <p className="mb-0">
          अनुसूचिमा उल्लेख भएको प्रस्ताव उद्घोषण तथा व्यक्तिगत स्वास्थ्य
          सम्बन्धी विवरणलाई यस करारको आधार मान्ने गरी सन नेपाल लाइफ इन्स्योरेन्स
          कम्पनी लिमिटेड (यसपछि बीमक भनिएको) ले प्राप्त गरेको र यस अनुसूचीमा
          उल्लेख गरे बमोजिम पहिलो बीमाशुल्क रकम प्राप्त भएकोले, अनुसूची बमोजिम
          बीमाशुल्क भुक्तानी गरेवापत जुन घटना घटेमा भुक्तानी दिने मनिएको हो सो
          घटना घटेमा बीमालेखमा उल्लेख भए बमोजिमको रकम बीमकले आफ्नो कार्यालयमा
          भुक्तानी दिनेछ भन्ने कुरा यस बीमालेखद्वारा पुष्टि गरिन्छ ।
        </p>

        <p>
          यस बीमालेखमा संलग्न अनुसुची शर्तहरु, पूरक करारहरु र सम्पुष्टिहरु यस
          करारको अंग मानिने छ ।
        </p>
        <p className="text-center font-semibold mt-0 mb-3">अनुसूची</p>
        <table className="w-full policy-paper--table-border mb-5">
          <tr>
            <td>
              <div>बीमालेख जारी गर्ने कार्यालय : {policyData.branchCode} </div>
            </td>
            <td>
              <div>बीमा अभिकर्ताको</div>
              <div>इजाजत पत्र नं :</div>
              <div>बीमा अभिकर्ता कोड नं : 30100000</div>
              <div>नाम, थर : Direct Agency</div>
            </td>
          </tr>
          <tr>
            <td>
              <div>बीमा अवधि : 5 वर्ष</div>
            </td>
            <td>
              <div>बीमालेख नम्बर : {policyData.policyNo}</div>
            </td>
          </tr>
          <tr>
            <td>
              <div>बीमितको</div>
              <div>नाम, थार : {policyData.insuredName}</div>
              <div>स्थायी ठेगाना : {policyData.address}</div>
            </td>
            <td>
              <div>बीमाङ्क रकम :</div>
              <div>अंकमा : {currencyFormat(policyData.sumAssured)}</div>
              <div>
                अक्षरमा :{" "}
                {policyData.sumAssured
                  ? converter.toWords(policyData.sumAssured) + " only"
                  : ""}
              </div>
              <div>
                बीमाशुल्क रकम रु. : {currencyFormat(policyData.premium)}
              </div>
              <div>
                बीमा प्रारम्भ मिति :{" "}
                {format(new Date(policyData.doc), "yyyy/MM/dd")}
              </div>
              <div>
                बीमा समाप्ति हुने मिति :{" "}
                {format(new Date(policyData.expiryDate), "yyyy/MM/dd")}
              </div>
              <div>बीमाशुल्क भुक्तानीको तरिका : वार्षिक</div>
            </td>
          </tr>
          <tr>
            <td>
              <div>इच्छाइएको व्यक्तिको</div>
              <div>नाम, थार : {policyData.nomineeName}</div>
              <div>ठेगाना : {policyData.nomineeAddress}</div>
              <div>इच्छाइएको व्यक्तिको माता / पिताको नाम :</div>
              <div>
                बीमित र इच्छाइएको व्यक्ति विचको नाता : {policyData.relation}
              </div>
            </td>
            <td>
              <div>
                नवीकरण बीमाशुल्क भुक्तानी गर्नुपर्ने मितिहरु :{" "}
                {format(new Date(policyData.nextDueDate), "yyyy/MM/dd")}
              </div>
              <div>
                अन्तिम बीमाशुल्क रकम भुक्तानी गर्नुपर्ने मिति :{" "}
                {format(new Date(policyData.lastPremiumPayDate), "yyyy/MM/dd")}
              </div>
              <div>
                बीमितको जन्म मिति :{" "}
                {format(new Date(policyData.dob), "yyyy/MM/dd")}
              </div>
              <div>उमेर खुल्ने प्रमाण : {policyData.documentType}</div>
              <div>
                प्रस्ताव मिति : {format(new Date(policyData.doc), "yyyy/MM/dd")}
              </div>
              <div>व्यक्तिगत स्वास्थ्य विवरण घोषणा मिति :</div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <div className="font-bold">
                बीमाङ्क रकम भुक्तानी दिइने अवस्था :
              </div>
              <div>
                चालु बीमालेखको बीमा समाप्त हुने मिति अगावै बीमितको मृत्यु भएमा
                बीमालेखको शर्तहरुको अधिनमा रही बीमाङ्क रकम भुक्तानी दिइनेछ ।
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <div className="font-bold">भुक्तानी पाउने व्यक्ति :</div>
              <div>
                बीमितले इच्छाएको व्यक्ति वा बीमा ऐन २०७९ को दफा १२७ बमोजिमको
                हकवाला भुक्तानी पाउने व्यक्ति हुनेछ । तर यस बीमालेख उपर कानूनी
                अधिकार भएको प्रमाणित गर्न सक्ने अरु कुनै व्यक्ति रहेको अवस्थामा
                निजले आफ्नो अधिकारसम्मको रकम भुक्तानी पाउनेछ ।
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <div className="font-bold">बीमाशुल्क भुक्तानी :</div>
              <div>
                बीमाशुल्कको पहिलो भुक्तानी बीमा प्रारम्भ मितिमा दिनुपर्नेछ ।
                नवीकरण बीमाशुल्क प्रत्येक वर्षको बीमाशुल्क भुक्तानी गर्नुपर्ने
                मितिमा दिनुपर्नेछ । अन्तिम बीमाशुल्क भुक्तानी गर्नुपर्ने मिति वा
                बीमितको मृत्यु भन्दा पहिले आखिरी बीमाशुल्क भुक्तानी गर्नुपर्ने
                मिति मध्ये जुनचाहिँ घटना पहिले घट्छ सो बीमाशुल्कको आखिरी
                भुक्तानी गर्नुपर्ने मिति हुनेछ ।
              </div>
            </td>
          </tr>
        </table>
        <div className="float-right">
          <p>अधिकार प्राप्त अधिकारीको :</p>
          <p className="flex">
            हस्ताक्षर :
            <span>
              <img
                src="/images/sign.png"
                alt="sign"
                width={80}
                className="ml-2"
              />
            </span>
          </p>
          <p>
            मिति : {format(new Date(policyData.createdDate), "yyyy/MM/dd")}
          </p>
        </div>
        <img
          src="/images/stamp.png"
          alt="sign"
          width={110}
          className="float-right"
        />
        <div className="float-clear"></div>
        <br />
        <br />
        <br />

        <h5 className="font-semibold text-center mb-5">सामान्य शर्तहरु</h5>

        <h5 className="font-semibold">१. बीमाशुल्क भुक्तानी :</h5>
        <ul className="ms-3">
          <li className="flex">
            <span className="mr-2">(क)</span>
            <span>
              प्रलोक नवीकरण श्रीमाशुल्क भुक्तानी गर्नका लागि तीस दिनको मोहलत
              अवधि दिइनेछ। तर मासिक बीमाशुल्क भुक्तानी विधि भएमा १५ दिन मात्र
              मोहलत अवधि दिइनेछ ।
            </span>
          </li>
          <li className="flex">
            <span className="mr-2">(ख)</span>
            <span>
              महलको अधभित्र पनि बीमाशुल्क भुक्तानी नगरिएमा बीमाले स्वतः व्यतीत
              हुनेछ।
            </span>
          </li>
          <li className="flex">
            <span className="mr-2">(ग)</span>
            <span>
              पूरा दुई वर्षको बीमाशुल्क भुक्तानी नहुँदै बीमालेख व्यतीत भएमा
              पुनजागरण नगरिएसम्म यस बीमालेख अन्तर्गत बीमकको कुनै दायित्व रहने
              छैन ।
            </span>
          </li>
          <li className="flex">
            <span className="mr-2">(घ)</span>
            <span>
              पूरा दुई वर्ष वा सोभन्दा अधिक बीमाशुल्क भुक्तानी भैसके पछि बीमा
              व्यतीत भएको अवस्थामा बीमितको मृत्यु भएमा देहाय बमोजिम हुनेछ
            </span>
          </li>
          <li className="flex ms-6">
            <span className="mr-2">(अ)</span>
            <span>
              बीमकलाई भुक्तानी नगरिएको मध्ये पहिली नविकरण बीमा शुल्क भुक्तानी
              गर्नुपर्ने मितिबाट एक वर्ष भित्र बीमितको मृत्यु भएमा सो मितिसम्म
              बीमितल भुक्तानी गर्नुपर्ने बीमाशुल्क कट्टा गरी बाँकी बीमा र
              नियमानुसारको बोनस मुक्तानी गरिनेछ ।
            </span>
          </li>
          <li className="flex ms-6">
            <span className="mr-2">(आ)</span>
            <span>
              बीमकलाई भुक्तानी नगरिएको मध्ये पहिला नवीकरण सीमाशुल्क भुक्तानी
              गर्नुपर्ने मितिबाट एक वर्षपछि बीमितको मृत्यु भएमा चुक्ता मूल्य
              मुक्तानी गरिने छ ।
            </span>
          </li>
          <li className="flex">
            <span className="mr-2">(ङ)</span>
            <span>
              अर्ध वार्षिक वा वैमानिक रुपमा बीमाशुल्क भुक्तानी हुने अवस्थामा सो
              वर्षको सबै बीमाशुल्क चुक्ता नीतिको मृत्यु भएको खण्डमा त्यस वर्षको
              निर्मितीमा बीमाङ्कबाट कट्टा गरिने छैन।
            </span>
          </li>
          <li className="flex">
            <span className="mr-2">(च)</span>
            <span>
              पूरा दुई वर्ष वा सो भन्दा बढी अवधिको बीमाशुल्क भुक्तानी भैसकेपछि
              बीमालेख व्यतीत भएमा स्वत चुक्ता बीमालेखमा परिणत भएको मानिने छ ।
            </span>
          </li>
        </ul>

        <h5 className="font-semibold">२. समर्पण मूल्य तथा कर्जा :</h5>
        <p>
          बीमालेख अन्तर्गत पूरा तीन वर्षको बीमाशुल्क प्राप्त भई बीमा प्रारम्भ
          मितिबाट तीन वर्ष पूरा भए पश्चात बीमालेख समर्पण गर्न तथा बीमालेख धितो
          राखी ऋण प्रदान गर्न सकिनेछ। समर्पण मूल्यको रकम नेपाल बीमा
          प्राधिकारणबाट स्वीकृत विधि प्रयोग गरी बीमकले निधारण गर्नेछ। बीमालेख
          उपर कानूनी स्वामित्व भएको सत्तीजनक प्रमा ण पेश गरेको खण्डमा समर्पण
          मूल्य भएको बीमालेखको धितोमा बीमा समाप्ती मिति पूर्व कुनैपनि समयमा
          बीमकबाट कर्जा प्राप्त गर्न सकिनेछ । कर्जाको रकम पटिमा समर्पण मूल्यको
          ५० प्रतिशत घटीमा ५०००/- (एक हजार सम्म मात्र) हुने कुनै पनि समय बिना
          सूचना कजो फिर्ता गर्न सकिनेछ। यस अन्तर्गत लिएको कुनै कर्जामा नेपाल
          बीमा प्राधिकारणको स्वीकृति लिई समय समयमा बीमकले निर्धारण गरे जिसको
          दरमा ब्याज लगाइनेछ। यदि कुनै अवस्थामा समर्पण मूल्यभन्दा कर्जा रकम र
          तिन बाकी याज बढी भएमा बीमालेख जफत गरी कजा र तिन बाँकी ब्याज असुल उपर
          गरिनेछ ।
        </p>

        <h5 className="font-semibold">३. समर्पण मूल्य तथा कर्जा :</h5>
        <p>
          बीमालेखको स्वामित्व भएको व्यक्तिको अनुरोधमा पुरा दुई वर्षको बीमाशुल्क
          भुक्तानी भैसकेको बीमालेखको बीमालाई प्राप्त बीमाशुल्क कि स्ताको आधारमा
          समानुपातिक हिसाबले घटाई बाकी बीमाशुल्क लिन नपर्ने गरिनेछ। नेपाल सीमा
          प्राधिकारणबाट स्वीकृत विधि प्रयोग गरी बीमकले घट्न गएको बीमा रकम
          निर्धारण गर्नेछ। भुक्तानी भएको सीमाशुल्क किस्ताको आधारमा मूल बीमाइले
          थप पाएको बोनस रकम घटाइने छैन र कायम हुन आएको सीमामा प गरिन। त्यसपछि
          कुनै बोनस रकम प्रदान गरिने छैन ।
        </p>

        <h5 className="font-semibold">४. समर्पण मूल्य तथा कर्जा :</h5>
        <p>
          बीमकले कुनै खर्च व्यहोर्नु नपर्ने गरिबीमितले आफू जीवन बीमाको लागी
          निरन्तर योग्य छु भनी बीमकले तोके बमोजिमको सन्तोषजनक प्रमाण पेश गर्नुका
          साथै बीमा समितिमा स्वीकृत दरमा व्याज सहित तिनं चाबी बीमाशुल्क रकम
          भुक्तानी गरेमा बीमा अवधि भित्र कुनै पनि समयमा बीमालेख नजागरण गर्न
          सकिनेछ ।
        </p>

        <h5 className="font-semibold">५. उमेरको प्रमाण :</h5>
        <p>
          बीमितको उमेरको सन्तोषजनक प्रमाण प्राप्त नभएसम्म यस बीमालेख अन्तर्गतको
          कुनै रकम पनि भुक्तानी दिइने छैन। यदि बीमितको जन्ममिति अनुसूचीमा उल्लेख
          गरिएभन्दा अगावै भएमा बीमालेख अन्तर्गत मुक्तानी दिइने मूल सीमाइ रकमलाई
          बीमितको वास्तविक जन्ममिति उल्लेख गरेको अवस्थामा भुक्तानी गर्नुपर्ने
          बीमाशुल्क अनुसार गणना गरी उक्त सीमा घटाइनेछ । यदि वास्तविक जन्ममिति
          अनुसूचिमा उल्लेख गरेभन्दा पछि भएमा अनुसूचिमा उल्लेख गरेको बीमा रकम यस
          बीमालेख अन्तर्गत भुक्तानी दिइनेछ तर वास्तविक जन्ममिति अनुसार जम्मा
          गर्नुपर्ने बीमाशुल्क रकमको योगफल भन्दा जम्मा गरिएको सीमाशुल्क रकमको
          योगफल बढी भएमा यस्तो फरक रकम फिर्ता गरिनेछ ।
        </p>

        <h5 className="font-semibold">६. अख्तियार :</h5>
        <p>
          बीमितले यस बीमालेखबाट प्राप्त हुने लाभ कसैलाई अख्तियारी पत्र दिई
          हस्तान्तरण गर्न सक्नेछ l यसरी बीमालेख अन्तर्गतको लाभ हस्तान्तरण गरेको
          कुरा बीमक समक्ष लिखित रुपमा जानकारी नगराएसम्म लागु हुनेछैन । त्यसरी
          हस्तान्तरण गरिएको अख्तियारी फिर्ता गर्नुपरेमा लिखित रुपमा बीमकको
          सम्बन्धित शाखा कार्यालयमा सूचित गर्नुपर्नेछ ।
        </p>

        <h5 className="font-semibold">७. इच्छाएको व्यक्ति :</h5>
        <p>
          बीमितको मृत्यु भएको खण्डमा यस बीमालेख अन्तर्गत मुक्तानी गरिने रकम
          प्राप्त गर्ने व्यक्ति बीमितले इच्छाएको छ भने निजको नाम तथा ठेगानालाई
          पीमासो अनुसूचीमा उल्लेख गरिने छ। यदि बीमितने इच्छाएको व्यक्ति बदल्ने
          नि र्णय गरेमा नयाँ इच्छाएको व्यक्तिको नाम र ठेगानालाई सीमालेखमा
          सम्पुष्टी जनाउनको लागी बीमालेख सहित लिखित अनुरोध यस बीमकको कार्यालयमा
          पठाउनु पर्नेछ। बीमकले यस बीमालेखमा परिवर्तन नगरेसम्म इच्छाएको
          व्यक्तिको परिवर्तनले कुनै कानूनी मान्यता पाउने छैन। बीमितको मृत्यु
          हुँदा इच्छाएको व्यक्ति निवित भएमा निजले माल अन्तर्गतको रकम पाउने छ ।
        </p>
        <p>
          तपूर्वक इच्छाएको व्यक्ति नभएमा बीमकले उक्त रकम बीमा ऐन २०४९ को दफा ३८
          बमोजिम बीमितका हकवालालाई दिनेछ ।
        </p>

        <h5 className="font-semibold">८. बीमालेख अन्तर्गत नपर्ने जोखिमहरु :</h5>
        <p>
          पदि बीमितको मृत्यु प्रत्यक्ष वा अप्रत्यक्ष रूपमा निम्न लिखित जुन सुकै
          कारणबाट भएपनि बीमालेख अन्तर्गत तिरिने रकम अनुसूचिमा उल्लेख गरेको बीमाङ
          मोजिम नभई बीमालेखको कुनै चुक्ता मूल्य रहेछ भने सो मा भुक्तानी हुने
        </p>

        <ul>
          <li className="flex">
            <span className="mx-3">(क)</span>
            <span>
              मान्यता प्राप्त हवाइवाद्वारा सञ्चालित मार्गमा यात्र भई उडान गर्दा
              बाहेक अन्य उडान गर्दा ।
            </span>
          </li>
          <li className="flex">
            <span className="mx-3">(ख)</span>
            <span>
              कानूनको वर्खिलाप हुने गरि कुनै युद्ध जस्ता कार्य युद्ध घोषित होस्
              या नाहीस मा संलग्न भएमा ।
            </span>
          </li>
          <li className="flex">
            <span className="mx-3">(ग)</span>
            <span>नागरिक वा जंगी ऐन भंग गरेमा ।</span>
          </li>
          <li className="flex">
            <span className="mx-3">(घ)</span>
            <span>
              मराज बिग्रेको होस् या नहोस् बीमा प्रारम्भ मितिले २ वर्ष भित्र
              आत्महत्या गरेमा । उपरोक्त जोखिमहरु बाहेक, यस बीमालेखले विदेशमा
              प्रवास यात्रा वा पेशा गर्न कुनै बाधा पुरयाउने छैन ।
            </span>
          </li>
        </ul>
        <p>
          ९. यस बीमालेख अन्तर्गत कुनै विवाद उत्पन्न भएमा बीमा ऐन, २०४९ यमोजिम
          हुनेछ ।
        </p>
        <p>१०. संलग्न सम्पुष्टिहरू ।</p>
      </div>

      <div className="policy-paper-wrapper">
        {header()}
        <h6 className="text-center font-bold mb-5">
          बीमालेख अन्तर्गत बीमितको मृत्यु भएमा किरिया खर्च बापत थप रकम भुक्तानी
          दिने बारेको पूरक करार
        </h6>
        <p class="text-center mb-3">
          बीमालेख नं.: {policyData.policyNo} &nbsp;&nbsp;&nbsp;&nbsp; पूरक
          करारको क्रमाङ्क: FE {policyData.policyNo} &nbsp;&nbsp;&nbsp;&nbsp;
          पूरक करारको बीमाङ्क: 50,000
        </p>
        <p class="tx-1 mb-3">
          बीमित बीमा प्रस्ताव फारममा उल्लेख भएको पेशामा नै लागेको भएमा वा
          बीमितको पेशा परिवर्तनलाई बीमकले स्वीकार गरी यस पूरक करारको सम्पुष्टीमा
          जनाएको र यस पूरक करार बापतको बीमाशुल्क बीमकलाई भुक्तानी भई यो पूरक
          करारनामा लागू भएको अवस्थामा बीमितको मृत्यु भएमा बीमालेख र यस पूरक
          करारको विशेष शर्त तथा सम्पुष्टीको परिधि भित्र रही बीमालेखको अनुसूचीमा
          उल्लेखित भुक्तानी पाउने व्यक्तिलाई यस पूरक करारमा उल्लेखित किरिया खर्च
          बापत बीमाङ्कको २५ प्रतिशत अथवा बढीमा रु.५०,००० थप भुक्तानी गरिनेछ ।
        </p>
        <p className="mb-5">
          बीमालेखमा संलग्न गरिएको यो पूरक करार बीमालेखको अभिन्न अङ्ग मानिने छ र
          बीमालेखको अनुसूचीमा यसको क्रमाङ्क उल्लेख भएमा वा बीमालेखको सम्पुष्टी
          खण्डमा जनाइएमा मात्र यो पूरक करारको कानूनी मान्यता हुनेछ ।
        </p>

        <h5 class="text-center font-semibold mb-5">विशेष शर्तहरु</h5>

        <h5 class="font-semibold">१. पूरक करार क्रियाशिल हुने अवस्था :</h5>
        <p class="mb-3 ml-3">
          यो पूरक करार बीमालेखको शर्तहरुको अधिनमा रहने छ र बीमाशुल्क भुक्तानी भई
          बीमालेख चालु नभएसम्म वा बीमालेख व्यतित भएको भए पुनर्जागरण नभएसम्म यो
          पूरक करार लागु हुने छैन ।
        </p>
        <h5 class="font-semibold">२. रद्द</h5>
        <p class="mb-3 ml-3">
          बीमितले लिखित सुचना गरेमा बीमालेखको कुनै पनि वार्षिकोत्सव मिति (बीमा
          शुरु भएको) मा यो पूरक करार रद्द गर्न सकिनेछ । यसरी रद्द गर्दा
          सम्पुष्टि (Endorsement) को लागि पूरक करार बीमक समक्ष पेश गर्नुपर्ने छ
          ।
        </p>
        <h5 class="font-semibold ml-3">२.१. स्वतः रद्द</h5>
        <p class="ms-10">देहाय अवस्थामा यो पूरक करार स्वतः रद्द हुनेछ</p>
        <ul class="mb-3 ms-10">
          <li>
            (क) बीमालेख वा पूरक करार अन्तर्गत तिर्नुपर्ने बीमाशुल्क नतिरेमा,
          </li>
          <li>
            (ख) बीमालेख चालु नरही चुक्ता मूल्यमा परिणत भएमा वा खारेज भएमा,
          </li>
          <li>(ग) बीमालेखको वार्षिकोत्सवमा बीमितको उमेर ७० वर्ष पुरा भएमा,</li>
        </ul>
        <h5 class="font-semibold ml-3">२.२ बीमाशुल्क</h5>
        <p class="mb-3 ms-10">
          यो पूरक करार रद्द वा खारेज भएमा यसको लागि लाग्ने थप बीमाशुल्क तिर्नु
          पर्दैन । बीमालेख रद्द वा खारेजीको बेलामा भुक्तानी दिएको थप बीमाशुल्क
          बीमकले आर्जन नगरेको हो भने सो रकमको साथै रद्द भएपछि प्राप्त हुन आएको
          पूरक करार अन्तर्गतको थप बीमाशुल्क बीमकले फिर्ता दिनेछ । यसपछिको
          भुक्तानी भएमा यस्तो बीमाशुल्क फिर्ता गर्नु बाहेक बीमकको अरु कुनै
          दायित्व रहने छैन ।
        </p>
        <h5 class="font-semibold">३. सुरक्षण नहुने जोखिमहरु :</h5>
        <p class="ml-3">
          देहायको अवस्थामा बीमितको मृत्यु भएमा यो पूरक करार लागु हुने छैन
        </p>
        <ul class="mb-3 ms-3">
          <li>
            (क) मान्यता प्राप्त हवाई सेवाद्वारा संचालित मार्गमा यात्रु भई उडान
            गर्दा बाहेक अन्य उडान गर्दा,
          </li>
          <li>(ख) मगज बिग्रेको होस् वा नहोस् आत्महत्या वा आत्मघात गरेमा,</li>
          <li>
            (ग) कुनै घोषित वा अघोषित युद्ध जस्ता कार्यहरु हुलदङ्गा हुलदङ्गश,
            नागरिक अशान्ति वा आक्रमणमा सक्रिय संलग्न भएमा,
          </li>
          <li>(घ) ज्यान मार्ने वा जङ्गी वा निजामती कानून उल्लंघन गरेमा,</li>
          <li>
            (ङ) बीमित कुनै पनि युद्धरत (घोषित वा अघोषित) मुलुकको स्थल सेना, जल
            सेना वा वायु सेना सदस्य भए‌मा,
          </li>
          <li>
            (च) बीमित कुनै पनि युद्धरत (घोषित वा अघोषित) मुलुकको स्थल सेना, जल
            सेना वा बायुसेनासंग काम गरिरहेको कुनै सहायक वा युद्धमा भाग नलिने
            निजामती इकाईको सदस्य भएमा,
          </li>
          <li>(छ) दौड, होडबाजी, बाजी वा हांक प्रतियोगितमा भाग लिंदा ।</li>
        </ul>
        <h5 class="font-semibold">४. पेशा परिवर्तन</h5>
        <p class="mb-3 ml-3">
          यदि बीमितले प्रस्ताव फाराममा उल्लेख गरेको पेशा परिवर्तन गरेमा वा
          प्रस्ताव फाराममा उल्लेख गरेको भन्दा अन्य थप जोखिमपूर्ण उद्यम सुचारु
          गरेमा सो कुराको जानकारी बीमकलाई अविलम्ब दिनु पर्नेछ र सो को आधारमा यस
          पूरक करार अन्तर्गत लाग्ने बीमाशुल्क पुनः निर्धारण गरिनेछ।
        </p>
        <h5 class="font-semibold">५. दावी सुचना :</h5>
        <p class="mb-10 ml-3">
          दाबीको सूचना अविलम्ब बीमकलाई दिनु पर्नेछ । तत्कालै सुचना दिन नसकेमा
          कारण जनाई लिखित रुपमा ९० दिन भित्र दिन सकिनेछ ।
        </p>
        <div className="flex justify-end">
          <img src="/images/stamp.png" alt="sign" width={110} className="" />
          <div class="text-end">
            <img
              src="/images/sign.png"
              alt="sign"
              width={100}
              className="ml-auto"
            />
            <p>(आधिकारीक हस्ताक्षर)</p>
          </div>
        </div>
      </div>
    </>
  );
}
